<template>
  <div :class="is_expired ? 'has-text-success' : 'has-text-info'">
    <span v-if="!is_expired">
      <span v-if="days > 0">{{ days }} Hari</span>
      <span v-if="hours > 0">{{ hours }} Jam</span>
      <span v-if="minutes > 0">{{ minutes }} Menit</span>
      <span v-if="seconds > 0">{{ seconds }} Detik</span>
    </span>
    <span v-else>SELESAI</span>
  </div>
</template>

<script>
export default {
  props: {
    finished: {
      type: String,
      required: true
    },
    onExpired: {
      type: Function,
      default: () => {}
    }
  },

  mounted() {
    this.bind()
  },

  watch: {
    is_expired(val) {
      if (val) {
        this.onExpired();
      }
    }
  },

  data() {
    return {
      is_expired: false,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  },

  methods: {
    bind() {
      const vm = this;

      var countDownDate = moment(vm.finished).local().valueOf();
      // Update the count down every 1 second
      var x = setInterval(function() {
        // Get todays date and time
        var now = moment().local().valueOf();
        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // Output the result in an element with id="demo"
        vm.days = days;
        vm.hours = hours;
        vm.minutes = minutes;
        vm.seconds = seconds;
        // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(x);
          vm.is_expired = true;
        }
      }, 1000);
    }
  }
}
</script>

<style>

</style>
